// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"089d450d","488":"83e83a0f"}[chunkId] + ".chunk.js";
};